import React from 'react'
import { Link } from 'react-router-dom'
import Header from '../../components/Header'
import Footer from '../../components/Footer'
import transfService from '../../images/transfer.jpg'
import fidel from '../../images/fidel.jpg'
import online from '../../images/enligne.jpg'
import partenaire from '../../images/partenaire.jpg'

function Services() {
  return (
    <>
        <Header/>
        <div className='pere mt-10 mr-5 ml-5 md:w-[450px] md:mx-auto'>
        <Link to='/'>
        <div className='box1 mb-10 mx-auto'>
        <h4 className='text-center font-bold'>Envoyer et Recevoir de l'argent en Euro</h4>
        <img className='w-[150] h-[100px] mx-auto' src={transfService} alt=''/>
        <p className='text-justify'>Transférez de l'argent en Euro en toute sécurité et rapidité grâce à notre plateforme conviviale. Facilitez le soutien financier à vos proches où qu'ils se trouvent.</p>
       </div>
       </Link>
       
       <Link to='http://m.me/YALWAS'>
       <div className='box2 mb-10  mx-auto'>
       <h4 className='text-center font-bold'>Paiement en Ligne des Factures</h4>
        <img className='w-[150] h-[100px] mx-auto' src={online} alt=''/>
        <p className='text-justify'>Réglez vos factures en ligne en quelques clics. Simplifiez vos paiements et évitez les tracas liés aux paiements en personne.</p>
       </div>
       </Link>

       <Link to='http://m.me/YALWAS'>  
       <div className='box3 mb-10 mx-auto'>
       <h4 className='text-center font-bold'>Fidélisation des Clients</h4>
        <img className='w-[200] h-[150px] mx-auto' src={fidel} alt=''/>
        <p className='text-justify'>Profitez de notre programme de fidélisation pour des avantages exclusifs. Gagnez des récompenses à chaque transaction et économisez sur vos frais de transfert.</p>
       </div>
       </Link>

       <Link to='http://m.me/YALWAS'>  
       <div className='box4 mb-10  mx-auto'>
       <h4 className='text-center font-bold mb-[20px]'>Partenariats</h4>
        <img className='w-[150] h-[100px] mx-auto mb-[20px]' src={partenaire} alt=''/>
        <p className='text-justify'>Explorez des opportunités de partenariats pour étendre votre présence et offrir nos services à un public plus large. Devenez un partenaire YALWAS et bénéficiez de collaborations mutuellement avantageuses.</p>
       </div>
       </Link>

        </div>
        <Footer/>
    </>
  )
}

export default Services